import styled from 'styled-components'
import { colors, helpers } from 'client/styles'

export const Container = styled.label`
  display: block;
  width: 60px;
  height: 36px;
  cursor: pointer;
`

export const Checkbox = styled.input`
  ${helpers.isVisuallyHidden}
`

export const Handle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  inset-inline-start: 3px;
  inset-block-start: 3px;
  transition: transform 0.2s ease-in-out;

  svg {
    fill: ${colors.grey3};
  }
`

export const Switch = styled.div`
  border-radius: 75px;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${props => (props.isOn ? colors.magenta : colors.grey3)};
  transition: background-color 0.2s ease-in-out;

  ${props =>
    props.isOn &&
    `
    ${Handle} {
        transform: translateX(calc(var(--transform-direction) * 24px));

        svg {
            fill: ${colors.magenta}
        }
    }
  `}
`
